import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { VersionHistory } from 'companySettings/components/PartFinderVersionHistory';
import { useGetPartFinderAttributeVersions } from 'companySettings/hooks';
import { IPartFinderAttribute, IPartFinderAttributeChanges } from 'companySettings/types';

import { PartFinderAttributeCompare } from './PartFinderAttributeCompare';
import { formatAttributeChanges } from '../utils';

interface IProps {
  attribute: IPartFinderAttribute;
}

// The status pill of an open list; it opens the list's published versions, two of which can be
// compared.
export const PartFinderAttributeVersionHistory = ({ attribute }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const {
    data: versions = [],
    isLoading,
    isError,
  } = useGetPartFinderAttributeVersions(attribute.id, isOpen);

  return (
    <VersionHistory
      status={attribute.status}
      versionNumber={attribute.versionNumber}
      versions={versions}
      isLoading={isLoading}
      isError={isError}
      errorMessage={t('errorTitlePartFinderAttributeVersionsFetch')}
      formatChanges={(changes: IPartFinderAttributeChanges, isPublish: boolean) =>
        formatAttributeChanges(attribute.type, changes, t, isPublish)
      }
      renderCompare={(fromVersionId, toVersionId, isCompareOpen, onClose) => (
        <PartFinderAttributeCompare
          attribute={attribute}
          fromVersionId={fromVersionId}
          toVersionId={toVersionId}
          isOpen={isCompareOpen}
          onClose={onClose}
        />
      )}
      onOpenChange={setIsOpen}
    />
  );
};
